/*
 * 木子 Li 酒館 — Custom JS
 * Phase 1 — Age verification, Inquiry list, LINE panel
 */

/* ==============================================
   ⚠️ LINE Official Account URL — EDIT HERE
   ============================================== */
var MUZI_LINE_URL = 'https://lin.ee/Yqtm3Tz';

/* ==============================================
   B. Age Verification
   ============================================== */
(function () {
  var AGE_KEY = 'muzi_li_age_verified';

  if (localStorage.getItem(AGE_KEY) === '1') {
    return;
  }

  function buildModal() {
    var overlay = document.createElement('div');
    overlay.className = 'muzi-age-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', '年齡確認');

    overlay.innerHTML =
      '<div class="muzi-age-modal">' +
      '<p class="muzi-age-modal__brand">木子 Li 酒館<small>SAKE SELECT</small></p>' +
      '<p class="muzi-age-modal__text">本網站含酒類商品資訊，請確認您已年滿 18 歲。</p>' +
      '<p class="muzi-age-modal__text">未滿 18 歲請勿瀏覽。</p>' +
      '<div class="muzi-age-modal__actions">' +
      '<button class="muzi-age-btn muzi-age-btn--confirm" id="muziAgeConfirm">我已滿 18 歲</button>' +
      '<a class="muzi-age-btn muzi-age-btn--leave" href="https://www.google.com">離開網站</a>' +
      '</div></div>';

    document.body.appendChild(overlay);

    document.getElementById('muziAgeConfirm').addEventListener('click', function () {
      localStorage.setItem(AGE_KEY, '1');
      overlay.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildModal);
  } else {
    buildModal();
  }
})();

/* ==============================================
   D. Inquiry List — localStorage based, max 5
   ============================================== */
var MUZI_INQUIRY_KEY = 'muzi_li_inquiry_list';

function getInquiryList() {
  try {
    return JSON.parse(localStorage.getItem(MUZI_INQUIRY_KEY)) || [];
  } catch (e) {
    return [];
  }
}

function saveInquiryList(list) {
  localStorage.setItem(MUZI_INQUIRY_KEY, JSON.stringify(list));
  updateLineBadge();
}

function isInInquiryList(handle) {
  return getInquiryList().some(function (item) {
    return item.handle === handle;
  });
}

function addToInquiryList(product) {
  var list = getInquiryList();
  if (isInInquiryList(product.handle)) {
    return; /* already in list */
  }
  if (list.length >= 5) {
    showToast('詢問清單最多可加入 5 款酒，建議分批詢問。');
    return false;
  }
  list.push(product);
  saveInquiryList(list);
  updateInquiryButtons();
  return true;
}

function removeFromInquiryList(handle) {
  var list = getInquiryList().filter(function (item) {
    return item.handle !== handle;
  });
  saveInquiryList(list);
  renderPanelItems();
  updateInquiryButtons();
}

/* ==============================================
   Toast notification
   ============================================== */
function showToast(message) {
  var existing = document.querySelector('.muzi-toast');
  if (existing) existing.remove();

  var toast = document.createElement('div');
  toast.className = 'muzi-toast';
  toast.textContent = message;
  document.body.appendChild(toast);

  /* Force reflow for transition */
  toast.offsetHeight;
  toast.classList.add('show');

  setTimeout(function () {
    toast.classList.remove('show');
    setTimeout(function () {
      toast.remove();
    }, 300);
  }, 2500);
}

/* ==============================================
   Update inquiry buttons on all product cards
   ============================================== */
function updateInquiryButtons() {
  var list = getInquiryList();
  var handles = list.map(function (item) {
    return item.handle;
  });
  var buttons = document.querySelectorAll('.muzi-inquiry-btn');
  buttons.forEach(function (btn) {
    var handle = btn.getAttribute('data-product-handle');
    var isProductCTA = btn.classList.contains('muzi-product__line-cta');
    if (handles.indexOf(handle) > -1) {
      if (!isProductCTA) {
        btn.textContent = '已加入詢問';
      }
      btn.classList.add('in-list');
    } else {
      if (!isProductCTA) {
        btn.textContent = '＋加入詢問';
      }
      btn.classList.remove('in-list');
    }
  });
}

/* ==============================================
   Update LINE icon badge
   ============================================== */
function updateLineBadge() {
  var badge = document.getElementById('muziLineBadge');
  if (!badge) return;
  var count = getInquiryList().length;
  if (count > 0) {
    badge.textContent = count;
    badge.style.display = 'flex';
  } else {
    badge.style.display = 'none';
  }
}

/* ==============================================
   E. Inquiry Panel
   ============================================== */
function togglePanel(force) {
  var panel = document.getElementById('muziInquiryPanel');
  var overlay = document.getElementById('muziPanelOverlay');
  if (!panel || !overlay) return;

  var isOpen = panel.classList.contains('open');
  var open = typeof force === 'boolean' ? force : !isOpen;

  if (open) {
    renderPanelItems();
    panel.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  } else {
    panel.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
}

function renderPanelItems() {
  var body = document.getElementById('muziPanelBody');
  var countEl = document.getElementById('muziPanelCount');
  if (!body) return;

  var list = getInquiryList();

  if (countEl) {
    countEl.textContent = list.length + '/5';
  }

  if (list.length === 0) {
    body.innerHTML =
      '<p class="muzi-panel__empty">尚無酒款<br>請至商品列表加入詢問</p>';
    return;
  }

  var html = '';
  list.forEach(function (item) {
    html +=
      '<div class="muzi-panel__item">' +
      '<div class="muzi-panel__item-info">' +
      '<p class="muzi-panel__item-name">' +
      escapeHTML(item.title) +
      '</p>' +
      '<p class="muzi-panel__item-price">' +
      '參考價格：' +
      escapeHTML(item.price) +
      '</p>' +
      '</div>' +
      '<button class="muzi-panel__item-remove" data-handle="' +
      escapeHTML(item.handle) +
      '" aria-label="移除">✕</button>' +
      '</div>';
  });
  body.innerHTML = html;

  /* Bind remove buttons */
  body.querySelectorAll('.muzi-panel__item-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      removeFromInquiryList(btn.getAttribute('data-handle'));
    });
  });
}

function escapeHTML(str) {
  var div = document.createElement('div');
  div.appendChild(document.createTextNode(str));
  return div.innerHTML;
}

/* ==============================================
   Build LINE message and open
   ============================================== */
function buildLineMessage() {
  var list = getInquiryList();
  var note = document.getElementById('muziPanelNote');
  var noteText = note ? note.value.trim() : '';

  var lines = [];
  lines.push('您好，我想詢問以下酒款：');
  lines.push('');

  if (list.length === 0) {
    lines.push('您好，我想詢問日本酒選品。');
  } else {
    list.forEach(function (item, i) {
      lines.push(i + 1 + '. ' + item.title);
      lines.push('   價格 / 參考價格：' + item.price);
      lines.push('   商品頁：' + item.url);
      lines.push('');
    });
  }

  lines.push('我已滿 18 歲。');

  if (noteText) {
    lines.push('備註：' + noteText);
  }

  return encodeURIComponent(lines.join('\n'));
}

function openLine() {
  var msg = buildLineMessage();
  var url = MUZI_LINE_URL;
  /* Append message only if LINE supports it; standard LINE share uses ?text= */
  if (url.indexOf('?') > -1) {
    url += '&text=' + msg;
  } else {
    url += '?text=' + msg;
  }
  window.open(url, '_blank', 'noopener');
}

/* ==============================================
   Initialize DOM elements and event bindings
   ============================================== */
function initMuziLi() {
  /* Build LINE icon and panel */

  /* LINE icon button */
  var lineIcon = document.createElement('button');
  lineIcon.className = 'muzi-line-icon';
  lineIcon.setAttribute('aria-label', 'LINE 詢問');
  lineIcon.innerHTML =
    '<svg viewBox="0 0 24 24"><path d="M19.365 9.863a.631.631 0 010 1.261H17.61v1.125h1.755a.63.63 0 110 1.261H16.98a.63.63 0 01-.63-.63V9.868a.63.63 0 01.63-.63h2.385zM15.107 9.863a.63.63 0 010 1.261h-.742v3.378a.63.63 0 01-1.261 0v-3.378h-.743a.63.63 0 010-1.261h2.746zM11.414 9.863a.63.63 0 010 1.261h-.531v1.251h.531a.63.63 0 010 1.261H9.62a.63.63 0 01-.63-.63V9.868a.63.63 0 01.63-.63h1.795zM8.216 9.863a.63.63 0 110 1.261h-.531v.505h.531a.63.63 0 010 1.261h-.531v.505h.531a.63.63 0 110 1.261H6.423a.63.63 0 01-.63-.63V9.868a.63.63 0 01.63-.63H8.216zM21.516 8.12H2.484a.63.63 0 00-.63.63v7.462a.63.63 0 00.63.63h19.032a.63.63 0 00.63-.63V8.75a.63.63 0 00-.63-.63zm-9.514 8.94c-5.098 0-9.233-3.18-9.233-7.104 0-3.506 3.097-6.456 7.233-7.07v3.34a2.598 2.598 0 00-1.96 1.23h1.96v1.24h-2.31a2.55 2.55 0 00-.03.3h2.34v1.24h-2.36a2.61 2.61 0 002.36 1.52v2.39c-7.01 0-12.69-4.44-12.69-9.92S5.45 2.02 12 2.02s12.69 4.44 12.69 9.92c0 2.46-1.16 4.72-3.09 6.33h-9.6z"/></svg>' +
    '<span class="muzi-line-icon__badge" id="muziLineBadge" style="display:none">0</span>';

  document.body.appendChild(lineIcon);

  lineIcon.addEventListener('click', function () {
    togglePanel();
  });

  /* Panel overlay */
  var overlay = document.createElement('div');
  overlay.className = 'muzi-panel-overlay';
  overlay.id = 'muziPanelOverlay';
  overlay.addEventListener('click', function () {
    togglePanel(false);
  });
  document.body.appendChild(overlay);

  /* Panel */
  var panel = document.createElement('div');
  panel.className = 'muzi-inquiry-panel';
  panel.id = 'muziInquiryPanel';
  panel.innerHTML =
    '<div class="muzi-panel__header">' +
    '<div><span class="muzi-panel__title">詢問清單</span> <span class="muzi-panel__count" id="muziPanelCount">0/5</span></div>' +
    '<button class="muzi-panel__close" id="muziPanelClose" aria-label="關閉">✕</button>' +
    '</div>' +
    '<div class="muzi-panel__body" id="muziPanelBody">' +
    '<p class="muzi-panel__empty">尚無酒款<br>請至商品列表加入詢問</p>' +
    '</div>' +
    '<textarea class="muzi-panel__note" id="muziPanelNote" rows="2" placeholder="例如：想送客戶，預算約 3000，希望清爽一點。"></textarea>' +
    '<div class="muzi-panel__footer">' +
    '<button class="muzi-panel__submit" id="muziPanelSubmit">透過 LINE 詢問</button>' +
    '</div>';
  document.body.appendChild(panel);

  document.getElementById('muziPanelClose').addEventListener('click', function () {
    togglePanel(false);
  });

  document.getElementById('muziPanelSubmit').addEventListener('click', function () {
    openLine();
  });

  /* Bind inquiry buttons on product cards */
  updateInquiryButtons();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.muzi-inquiry-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-product-handle');
    var title = btn.getAttribute('data-product-title');
    var price = btn.getAttribute('data-product-price');
    var url = btn.getAttribute('data-product-url');

    if (!handle) return;

    if (isInInquiryList(handle)) {
      /* Already in list — toggle panel to let user manage */
      togglePanel(true);
      return;
    }

    var result = addToInquiryList({
      handle: handle,
      title: title,
      price: price,
      url: url
    });

    if (result) {
      updateInquiryButtons();
    }
  });
}

/* Boot */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMuziLi);
} else {
  initMuziLi();
}

/* Re-run button update when Shopify sections reload (filtering/faceting AJAX) */
document.addEventListener('shopify:section:load', function () {
  updateInquiryButtons();
});

/* Expose for liquid-rendered buttons */
window.muziUpdateInquiryButtons = updateInquiryButtons;
